function defaultState() {
    return {
        email: '',
        token: undefined,
        redirectPath: undefined,
    };
}
const loginFlowStore = {
    namespaced: true,
    state: defaultState(),
    mutations: {
        email(state, email) {
            state.email = email;
        },
        token(state, token) {
            state.token = token;
        },
        redirectPath(state, redirectPath) {
            state.redirectPath = redirectPath;
        },
    },
    actions: {
        setData({ commit }, data) {
            commit('email', data.email);
            commit('token', data.token);
            commit('redirectPath', data.redirectPath);
        },
        clearAll({ dispatch }) {
            dispatch('setData', defaultState());
        },
    },
    getters: {
        all(state) {
            return state;
        },
        email(state) {
            return state.email;
        },
        token(state) {
            return state.token;
        },
        redirectPath(state) {
            return state.redirectPath;
        },
    },
};
export default loginFlowStore;
